import { render } from "./BlogComp.vue?vue&type=template&id=be20bd3c&ts=true"
import script from "./BlogComp.vue?vue&type=script&lang=ts"
export * from "./BlogComp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__